import config from '@/data/config';
import { httpV1 as http } from '../api';

export async function getTheme({ domain }) {
  // prevent CORS errors
  delete http.defaults.headers.common.Authorization;
  delete http.defaults.headers.common['X-Authorization'];

  return http.get(
    `/users/tenants/${domain}`,
    {
      headers: {
        'X-Authorization': config.API_KEY,
        'content-type': 'application/json',
      },
    },
  );
}
